import './chunk-1fafdf15.js';
import './chunk-6985c8ce.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { F as Field } from './chunk-eb60b35a.js';
export { F as BField } from './chunk-eb60b35a.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Field);
  }
};
use(Plugin);

export default Plugin;



//////////////////
// WEBPACK FOOTER
// ./~/buefy/dist/esm/field.js
// module id = 56
// module chunks = 10